import type { StoreWebForwardedEvent } from "@/platform/bridge/types"
import { type MetaTrackParams, resolveMetaEventId } from "@/platform/observability/analytics/meta"

export interface NativeEventForward {
  readonly name: StoreWebForwardedEvent
  readonly params: Record<string, unknown>
}

const NATIVE_NAMES: Readonly<Record<string, StoreWebForwardedEvent>> = {
  view_item_list: "VIEW_ITEM_LIST",
  select_item: "SELECT_ITEM",
  begin_checkout: "BEGIN_CHECKOUT",
  purchase: "PURCHASE",
  select_repayment_option: "checkout_plan_selected",
}

const conversionParams = (event: string, internalParams: MetaTrackParams): Record<string, unknown> => {
  if (event !== "purchase") return {}
  const conversionEventId = resolveMetaEventId("purchase", internalParams)
  return conversionEventId === undefined ? {} : { conversion_event_id: conversionEventId, conversion_surface: internalParams.conversionSurface ?? "marketplace" }
}

export const nativeEventFor = (event: string, params: Record<string, unknown>, internalParams: MetaTrackParams = {}): NativeEventForward | null => {
  const name = NATIVE_NAMES[event]
  return name === undefined ? null : { name, params: { ...params, ...conversionParams(event, internalParams) } }
}
